import { IconFileInvoice, IconPlus } from "@tabler/icons-react";
import { Button, Card, Heading, Stack, Text, ThemeIcon } from "@/components/ui";

/**
 * Estado vacío · sin solicitudes. El CTA a crear solo se muestra si `onCrear` viene
 * (hotspot 96 · solo con `solicitudes.gestionar`; quien solo consulta ve el texto).
 */
export function EmptyState({ onCrear }: { onCrear?: () => void }) {
  return (
    <Card padding="xl">
      <Stack align="center" gap="md" className="py-8">
        <ThemeIcon variant="filled" color="multiva" size="xl">
          <IconFileInvoice size={28} stroke={1.4} />
        </ThemeIcon>
        <Stack gap={4} align="center">
          <Heading order={4}>{onCrear ? "Aún no tienes solicitudes" : "Aún no hay solicitudes"}</Heading>
          <Text size="sm" c="dimmed" ta="center" className="max-w-100">
            {onCrear
              ? "Crea tu primera solicitud de pago · subir un CFDI, capturar datos generales, asignar proveedor, prorratear y enviar a autorización."
              : "Cuando se registren solicitudes de pago aparecerán aquí."}
          </Text>
        </Stack>
        {onCrear ? (
          <Button leftSection={<IconPlus size={16} />} onClick={onCrear}>
            Crear primera solicitud
          </Button>
        ) : null}
      </Stack>
    </Card>
  );
}

/** Estado vacío por filtros · CTA a limpiar. */
export function EmptyFiltro({ onLimpiar }: { onLimpiar: () => void }) {
  return (
    <Card padding="lg">
      <Stack align="center" gap="sm" className="py-4">
        <Text size="sm" c="dimmed">
          No hay solicitudes con esos filtros.
        </Text>
        <Button size="xs" variant="light" onClick={onLimpiar}>
          Limpiar filtros
        </Button>
      </Stack>
    </Card>
  );
}
